
import { defineComponent, ref } from "vue";
import Sidebar from "primevue/sidebar";
import Button from "primevue/button";
import ProgressBar from "primevue/progressbar";

import ConfigContent from "@/components/ConfigContent.vue";

import * as htmlToImage from "html-to-image";
import { useToast } from "primevue/usetoast";
import { saveAs } from "file-saver";

export default defineComponent({
  components: {
    Sidebar,
    Button,
    ProgressBar,
    ConfigContent,
  },
  setup() {
    const toast = useToast();
    let isSidebarVisible = ref(true);
    let isExporting = ref(false);

    const exportImage = function () {
      isExporting.value = true;

      toast.add({
        severity: "danger",
        summary: "Failed to export image",
        detail: "",
        life: 5000,
      });
      let node = document.getElementById("igfy-layout") as HTMLImageElement;
      htmlToImage
        .toSvg(node)
        .then((dataUrl) => {
          saveAs(dataUrl, "igfy-export");
          isExporting.value = false;
        })
        .catch((err) => {
          isExporting.value = false;

          toast.add({
            severity: "danger",
            summary: "Failed to export image",
            detail: err,
            life: 5000,
          });
          console.error(err);
        });
    };

    return { isSidebarVisible, isExporting, exportImage };
  },
});
